module.exports = __webpack_public_path__ + "static/_lethbridgeLogo-8f5c77ed403007a3b751eff0e60e7e8a.png";